import React from 'react'
import { SortableHandle } from 'react-sortable-hoc'
import { DragHandle } from '@material-ui/icons'
import { H3, P } from '../../../components'
import { StyledRow } from './styled'

const DragHandler = SortableHandle(DragHandle)

export const PrioritiesTableRow = ({ mediaType, dispatch }) => (
  <StyledRow key={mediaType.extension}>
    <td className="drag-handler">
      <DragHandler />
    </td>
    <td>
      <H3>{mediaType.title}</H3>
    </td>
    <td>
      <P>{mediaType.mediaContentType}</P>
    </td>
    <td>
      <P>{mediaType.extension}</P>
    </td>
    <td>
      <P>{mediaType.mimeType}</P>
    </td>
  </StyledRow>
)
